import { render, staticRenderFns } from "./DataBrowser.vue?vue&type=template&id=802d5ede"
import script from "./DataBrowser.vue?vue&type=script&lang=js"
export * from "./DataBrowser.vue?vue&type=script&lang=js"
import style0 from "./DataBrowser.vue?vue&type=style&index=0&id=802d5ede&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports